import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { OptionsColor } from "../OptionsColor";
export var BackgroundMaskCover = /*#__PURE__*/function () {
  function BackgroundMaskCover() {
    _classCallCheck(this, BackgroundMaskCover);

    this.color = new OptionsColor();
    this.color.value = "#fff";
    this.opacity = 1;
  }

  _createClass(BackgroundMaskCover, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }

      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);

  return BackgroundMaskCover;
}();